import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
//Services
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { RouterService } from "src/app/services/router/router.service";
import { TagsService } from "src/app/services/tags/tags.service";

@Component({
  selector: 'app-key-termminal-success',
  templateUrl: './key-termminal-success.page.html',
  styleUrls: ['./key-termminal-success.page.scss'],
})
export class KeyTermminalSuccessPage implements OnInit {

  constructor(
    public languageService: LanguagesService,
    public routerService: RouterService,
    private tagsService:TagsService,
    private platform: Platform,
  ) {}

  ngOnInit() {
    this.tagsService.setEventTag('advice_page','advice_screen_viewed',false,true);
  }

  get getTextIUPageOrdersSuccess() {
    return this.languageService.textsIU.page_payment_terminal;
  }

  redirectToCatalogue() {
    this.tagsService.setEventTag('advice_page','advice_rewards_clicked',false,true);
    this.routerService.redirect("app/catalogue");
  }

}
